import { FilterCount, FilterSection } from "@flights/search-ui";
import React from "react";
import { useAirportsFilterController } from "./useAirportsFilter.controller";
import { InputCheckbox, Stack, Text } from "@bookingcom/bui-react";
import styles from "./AirportsFilter.module.css";

export const AirportsFilter = () => {
  const { isFilterAvailable, title, options, value, onChange } = useAirportsFilterController();

  if (!isFilterAvailable || !options?.length) return null;

  return (
    <FilterSection
      attributes={{ "data-testid": "airports_filter" }}
      title={{
        text: title,
        tagName: "h3",
        attributes: { id: "airports_filter" },
        variant: "strong_2"
      }}
    >
      <Stack gap={4}>
        {options?.map((option) => (
          <Stack key={option.city} gap={2}>
            <Text
              variant="emphasized_2"
              tagName="h4"
              attributes={{
                "data-testid": `search_filter_airports_${option.city}`
              }}
            >
              {option.city}
            </Text>
            {option.airports.map((airport) => (
              <FilterCount key={airport.iata} count={airport.count}>
                <InputCheckbox
                  label={
                    <span className={styles.airportLabel}>
                      <b>{airport.iata}</b>
                      <Text color="neutral_alt" variant="body_2" className={styles.airportName}>
                        {" "}
                        {airport.name}
                      </Text>
                    </span>
                  }
                  value={airport.iata}
                  name={`airports-filter-${airport.iata}`}
                  checked={value.some((val) => val.iata === airport.iata)}
                  onChange={({ checked }) => onChange(checked, airport.iata)}
                  attributes={{
                    "data-testid": `search_filter_airports_${airport.name}`,
                    "aria-label": `${airport.name} ${airport.count}`
                  }}
                />
              </FilterCount>
            ))}
          </Stack>
        ))}
      </Stack>
    </FilterSection>
  );
};

export default AirportsFilter;
